import { compose } from 'redux';
import withForwardedPath from './withForwardedPath';
import SpanishStudentIFrame from './SpanishStudentIFrame';

const enhance = compose(withForwardedPath);

export default enhance(SpanishStudentIFrame);
